import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function GymAccount() {
  const [academy, setAcademy] = useState(null);
  useEffect(() => {
    api.get("/wholesale/my-academy").then(({ data }) => setAcademy(data)).catch(() => {});
  }, []);

  const rows = academy
    ? [
        ["Academy Name", academy.name],
        ["Code", academy.code],
        ["City", academy.city],
        ["State", academy.state],
        ["Contact", academy.contact_name || "—"],
        ["Email", academy.email || "—"],
        ["Phone", academy.phone || "—"],
        ["Status", academy.active ? "Active" : "Inactive"],
      ]
    : [];

  return (
    <div className="px-5 lg:px-8 py-8 max-w-2xl">
      <p className="font-mono text-emerald-400 uppercase tracking-widest text-xs">Account</p>
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">Academy Info</h1>
      <div className="bg-[#121216] border border-white/10 rounded-lg mt-6 divide-y divide-white/5">
        {rows.map(([k, v]) => (
          <div key={k} className="flex justify-between px-5 py-3.5">
            <span className="font-mono text-xs uppercase tracking-widest text-zinc-500">{k}</span>
            <span className="text-white text-sm">{v}</span>
          </div>
        ))}
      </div>
      <p className="text-zinc-600 text-xs mt-4">Need changes to your academy details? Contact Paragon Admin.</p>
    </div>
  );
}
